export default __webpack_public_path__ + "static/media/welcome_bg.24ecc68e.png";